<template>
  <div class="home">
    <div class="topBar">
      <span>

        <img src="https://file.njsyue.com/fs/data/homeimgs/home.png" alt="">
      </span>
      <div>
        <div>使命</div>
        <div>携手共创 拾阶而越</div>
      </div>
    </div>
    <div class="content">

      <div class="title">
        企业文化
        <span>corporate culture</span>
      </div>
      <div class="left-img-box">
        <div class="gray-bg"></div>
        <div class="flex-img-box">
          <div>
            <img src="https://file.njsyue.com/fs/data/homeimgs/culture1.png" alt="">
          </div>
          <div>
            <div class="mini-title"> 求真务实 </div>
            <div class="box-msg"> <span></span>独立思考，刨根问底，找到本质 </div>
            <div class="box-msg"> <span></span>直接体验，深入事实，拿一手数据和信息 </div>
          </div>
        </div>
      </div>
      <div class="left-img-box right">
        <div class="gray-bg"></div>
        <div class="flex-img-box">
          <div>
            <img src="https://file.njsyue.com/fs/data/homeimgs/culture2.png" alt="">
          </div>
          <div>
            <div class="mini-title"> 积极主动 </div>
            <div class="box-msg"> <span></span>积极回应，负起责任，发挥天赋 </div>
            <div class="box-msg"> <span></span>持续探索，不惧艰难 </div>
            <div class="box-msg"> <span></span>自我革新，全力以赴 </div>
          </div>
        </div>
      </div>
      <div class="left-img-box">
        <div class="gray-bg"></div>
        <div class="flex-img-box">
          <div>
            <img src="https://file.njsyue.com/fs/data/homeimgs/culture3.png" alt="">
          </div>
          <div>
            <div class="mini-title"> 共同成长 </div>
            <div class="box-msg"> <span></span>通过高效协同，追求团队进步 </div>
            <div class="box-msg"> <span></span>相信认同使命，有耐心有韧性，持续学习和组织一起成长 </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottomBar">
      <div>公司地址：南京市雨花台区软件大道180号南京大数据产业基地</div>
      <div>联系电话： 15805163017 黄女士</div>
      <div>版权所有：南京拾越信息科技有限公司</div>
      <div class="bottomBar-links">
        <span @click="go">备案号：苏ICP备17008551号</span>
        <span class="bottomBar-separator">|</span>
        <span @click="goPrivacy">隐私协议</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  methods: {
    go () {
      location.href = "https://beian.miit.gov.cn";
    },
    goPrivacy () {
      location.href = "https://www.njsyue.com/user/privacy.html";
    }
  }
};
</script>
<style lang="less" scoped>
.home {
  position: relative;
  width: 100%;
  height: calc(100vh - 100px);
  overflow: overlay;
  /* 毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.5); /* 白色背景颜色，透明度为 0.5 */
  backdrop-filter: blur(5px); /* 模糊效果 */
  /* 兼容性 */
  -webkit-backdrop-filter: blur(5px);

  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 14px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
    display: none;
  }
  .topBar {
    max-width: 1920px;
    position: relative;
    margin: 0 auto;
    > div {
      position: absolute;
      top: 0;
      left: 10%;
      width: 300px;
      height: 334px;
      background: #ffffff;
      border-radius: 0px 0px 150px 0px;
      padding: 94px 70px 85px;
      > :first-child {
        font-weight: bold;
        font-size: 24px;
        color: #999999;
        line-height: 31px;
        text-align: left;
      }
      > :last-child {
        margin-top: 20px;
        font-weight: bold;
        font-size: 40px;
        color: #082143;
        line-height: 52px;
        text-align: left;
      }
    }
    > span {
      width: 100%;
      min-height: 550px;
      display: inline-block;
      width: unset !important;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .content {
    padding: 0 10%;
  }
  .title {
    position: relative;
    font-weight: bold;
    font-size: 48px;
    color: #082143;
    line-height: 64px;
    text-align: left;
    // padding: 140px 0 110px;
    margin: 140px 0 110px;
    > span {
      display: inline-block;
      font-weight: bold;
      font-size: 48px;
      color: #f5f5f5;
      line-height: 64px;
      position: absolute;
      top: 41px;
      left: 0px;
    }
  }
  .right {
    > .flex-img-box {
      flex-direction: row-reverse;
      > :last-child {
        padding-right: 4.1vw;
        padding-left: 0px !important;
        // background: red;
      }
    }
  }
  .left-img-box {
    // height: 544px;
    position: relative;
    padding: 3vw 3.6vw 0;
    aspect-ratio: 1440 / 544; /* 4:3 的比例 */
    margin-bottom: 7.8vw;
    .flex-img-box {
      width: 100%;
      height: 100%;
      // background: red;
      display: flex;
      justify-content: space-between;
      > :first-child {
        width: 55.3%;
        // height: 484px;
        flex-shrink: 0px;
        > img {
          width: 100%;
        }
      }
      > :last-child {
        padding-left: 4.1vw;
        flex: 1;
        > .mini-title {
          font-weight: bold;
          font-size: 30px;
          color: #082143;
          line-height: 40px;
          margin-bottom: 1.7vw;
        }
        .box-msg {
          font-size: 22px;
          color: #082143;
          line-height: 29px;
          text-align: left;
          margin-bottom: 20px;
          position: relative;
          padding-left: 18px;
          > span {
            position: absolute;
            top: 10px;
            left: 0px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #082143;
            display: inline-block;
          }
        }
      }
    }
  }
  .gray-bg {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    aspect-ratio: 1440 / 346; /* 4:3 的比例 */
    background: #f3f4f8;
  }
}
</style>
